import React, { memo, useEffect, useState } from "react";
import Page from "../../core/components/shared/Page";
import ObPortfolioPfCard from "./ObPortfolioPfCard";
import ObOpportunitySection from "./ObOpportunitySection";
import { getAllBonds, getConsolidatedPortfolio } from "../services/waitlist-service";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { utils } from "../../core/helpers/utils";
import BiddFirstModal from "./BiddFirstModal";


const ObInvestmentOpportunitiesMain = memo(function ObInvestmentOpportunitiesMain(props) {
  // console.log(">> ObInvestmentOpportunitiesMain");
  const [isMobile, setIsMobile] = useState(false);
  const [oppLoader, setOppLoader] = useState(true);
  const [pfLoader, setPfLoader] = useState(true);
  const [opportunities, setOpportunities] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [investedAmt, setInvestedAmt] = useState(null);

  const fetchAllBondsDetails = () => {
    getAllBonds().then((result) => {
      const response = utils.parsePayload(result);
      // setOppLoader(false);
      if (!response || !response.success) {
        toast.error(response.message || "Error: Unable to fetch bonds details");
        return setOppLoader(false);
      ;
      }
      setOpportunities([...response.data]);
      return setOppLoader(false);
    });
  };

  useEffect(() => {
    try {
      setPfLoader(true);
      if (!props || !props?.portfolioDetails) {
        return console.log("err");
      }
      if (props?.portfolioDetails && props?.portfolioDetails?.consolidated?.investedAmt) {
        setInvestedAmt(props?.portfolioDetails?.consolidated?.investedAmt);
        let arrPortfolio = [
          {
            title: "Current Value",
            value:
              props?.portfolioDetails &&
              props?.portfolioDetails?.consolidated &&
              props?.portfolioDetails?.consolidated?.mtm
                ? props?.portfolioDetails?.consolidated?.mtm?.oroNumber(2, true)
                : 0,
          },
          {
            title: "Payouts",
            value:
              props?.portfolioDetails &&
              props?.portfolioDetails?.consolidated &&
              props?.portfolioDetails?.consolidated?.coupons
                ? props?.portfolioDetails?.consolidated?.coupons?.oroNumber(2, true)
                : 0,
          },
          {
            title: "Amount Invested",
            value:
              props?.portfolioDetails &&
              props?.portfolioDetails?.consolidated &&
              props?.portfolioDetails?.consolidated?.userInvestedAmnt
                ? props?.portfolioDetails?.consolidated.userInvestedAmnt.oroNumber(2, true)
                : 0,
          },
        ];
        let newArr = arrPortfolio.filter((obj) =>
          obj.title === "Coupons" && obj.value === 0 ? null : obj
        );
        setPortfolio(newArr);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setPfLoader(false);
    }
  },[props?.portfolioDetails])

  useEffect(() => {
    setOppLoader(true);
    setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    fetchAllBondsDetails();
  }, []);

  console.log("#12: ", oppLoader, pfLoader);

  return (
    <Page className="opportunity-main">
      {(oppLoader || pfLoader) ?
        <div className="home-loader w-100 d-flex justify-content-center align-items-center">
          <Spinner 
            style={{
              color: "#283A97"
            }}
          />
        </div>
      :
      <>
          {(investedAmt && portfolio) ? <ObPortfolioPfCard portfolio={portfolio} /> : null}
        
        {opportunities.length ? 
          <ObOpportunitySection
            opportunities={opportunities}
            isMobile={isMobile}
            oppLoader={oppLoader}
            userEmail={props && props.userEmail ? props.userEmail : ""}
            utm={props.utm}
          /> 
        : null}
        <BiddFirstModal />
      </>}
    </Page>
  );
});

export default ObInvestmentOpportunitiesMain;
